import { useCallback, useEffect, useState } from "react";
import { SimpleForm, Title, useNotify, useRefresh, useRedirect } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "../SaveForm";
import { useParams } from "react-router";
import dataProvider from "server/dataProvider";
import { employeeRequests } from "api/employeeApi";

const EditSickLeaves = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const [defaultValues, setDefaultValues] = useState(null);
  const { id } = useParams();

  const fetchDefaultValues = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(employeeRequests.getSickLeaveById(id), null, "GET");
      setDefaultValues(data);
    } catch (err) {
      notify(err.message || "Грешка при зареждане на данни", { type: "error" });
    }
  }, [id, notify])

  const handleSubmit = async data => {
    try {
      const { document, ...mainData } = data;
      await dataProvider.customRequest(employeeRequests.updateSickLeave(id), mainData, "PUT");

      if (document?.rawFile instanceof File) {
        await dataProvider.customRequest(
          employeeRequests.uploadLeaveDocument(id),
          {
            document: { rawFile: document.rawFile },
            id,
            description: data.documentNumber ?? "",
          },
          "POST",
          null,
          true
        );
      }

      notify("Успешно редактирахте болничния !", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notify(err.message || "Грешка при редактиране на болничния !", { type: "error" });
    }
  }

  useEffect(() => {
    if (id) {
      fetchDefaultValues()
    }
  }, [id, fetchDefaultValues]);

  return (
    <>
      <Title title={`Редактиране на болничен`} />
      <BackButtonToolbar />
      {defaultValues && (
        <SimpleForm
          defaultValues={defaultValues}
          onSubmit={handleSubmit}
          toolbar={false}
        >
          <SaveForm
            isCreate={false}
            onDocumentDelete={fetchDefaultValues}
          />
        </SimpleForm>
      )}
    </>
  );
}

export default EditSickLeaves;